import {
	ICampaignDetails,
	ICampaignDetailsWithExtras,
	ICampaignDigestDetailsWithExtras,
	ICampaignPostResponse,
	IDigestPostResponse,
	IServiceRegularErrorData,
	IServiceValidationErrorData,
} from '../../../campaigns/src/services/model';
import { INotificationActionPayload, INotificationProps } from '../../../notif/src/model';

export const instanceOfICampaignDetailsWithExtras = (object: any): object is ICampaignDetailsWithExtras => {
	return object.Campaign !== undefined;
};

export const instanceOfICampaignPostResponse = (object: any): object is ICampaignPostResponse => {
	return object.Campaign !== undefined;
};

export const instanceOfICampaignDigestDetailsWithExtras = (object: any): object is ICampaignDigestDetailsWithExtras => {
	return object.Digest !== undefined;
};

export const instanceOfIDigestPostResponse = (object: any): object is IDigestPostResponse => {
	return object.Digest !== undefined;
};

export const instanceOfNotificationActionPayload = (object: any): object is INotificationActionPayload => {
	return object.notification !== undefined;
};

export const instanceOfNotificationProps = (object: any): object is INotificationProps => {
	return object.message !== undefined && object.type !== undefined;
};

export const instanceOfValidationErrorResponse = (object: any): object is IServiceValidationErrorData => {
	return object.Code !== undefined && object.ValidationErrors;
};

export const instanceOfRegularErrorResponse = (object: any): object is IServiceRegularErrorData => {
	return object.Code !== undefined && object.ValidationErrors === undefined && object.Error !== undefined;
};

export const instanceOfICampaignDetails = (object: any): object is ICampaignDetails => {
	return object && object.CampaignName !== undefined && object.PluginId === undefined;
};
